import type { IMetadataRepository, MetadataCreateInput } from '../repositories/IMetadataRepository.js';
import type { MetadataEntity } from '../entities/MetadataEntity.js';

interface Deps { metadataRepository: IMetadataRepository; }
export function createCreateMetadataUseCase({ metadataRepository }: Deps) {
  return async function createMetadata(input: MetadataCreateInput): Promise<MetadataEntity> {
    return metadataRepository.create(input);
  };
}
